// Assets exports
// Font files and other static assets
// Platform utilities will be available when needed

export const assets = {} as const;
export * from './fae-avatar';
